<template>
  <div>
    <b-row class="my-1">
      <b-col cols="8">
        <label for="input-small">รวมเป็นเงิน</label>
      </b-col>
      <b-col cols="4" class="text-right">
        <label for="input-small">{{ form.rate_before_vat | number }}</label>
      </b-col>
    </b-row>
    <hr class="my-3" />
    <b-row class="my-1">
      <b-col cols="8">
        <b-form inline>
          <label for="input-small" class="mr-1">ค่าบริการ</label>
          <b-form-input
            size="sm"
            v-model="form.fee"
            class="mr-1 mw-50px hide-arrow"
            type="number"
            @input="$emit('calRate')"
          ></b-form-input>
          <label for="input-small">%</label>
        </b-form>
      </b-col>
      <b-col cols="4" class="text-right">
        <label for="input-small">{{ form.price_service_fee | number }}</label>
      </b-col>
    </b-row>
    <b-row class="my-1">
      <b-col cols="8">
        <label for="input-small">ราคาหลังเพิ่มค่าบริการ</label>
      </b-col>
      <b-col cols="4" class="text-right">
        <label for="input-small">{{
          form.price_after_service_fee | number
        }}</label>
      </b-col>
    </b-row>
    <hr class="my-3" />
    <b-row class="my-1">
      <b-col cols="8">
        <b-form inline>
          <label for="input-small" class="mr-1">ส่วนลด</label>
          <b-form-input
            size="sm"
            class="mr-1 mw-50px hide-arrow"
            type="number"
            v-model="form.discount"
            @input="$emit('calRate')"
          ></b-form-input>
          <label for="input-small">%</label>
        </b-form>
      </b-col>
      <b-col cols="4" class="text-right">
        <label for="input-small">{{ form.price_discount | number }}</label>
      </b-col>
    </b-row>
    <b-row class="my-1">
      <b-col cols="8">
        <label for="input-small">ราคาหลังหักส่วนลด</label>
      </b-col>
      <b-col cols="4" class="text-right">
        <label for="input-small">{{
          form.price_after_discount | number
        }}</label>
      </b-col>
    </b-row>
    <hr class="my-3" />
    <b-row class="my-1">
      <b-col cols="8">
        <b-form inline>
          <b-form-checkbox
            size="sm"
            v-model="form.checkVat"
            @input="$emit('calRate')"
          ></b-form-checkbox>
          <label for="input-small">ภาษีมูลค่าเพิ่ม</label>
          <b-form-input
            :disabled="!form.checkVat"
            size="sm"
            class="mx-1 mw-50px hide-arrow text-center"
            type="number"
            v-model="form.vatPercent"
            @input="$emit('calRate')"
          ></b-form-input>
          <label for="input-small">%</label>
        </b-form>
      </b-col>
      <b-col cols="4" class="text-right">
        <label for="input-small">{{ form.vat | number }}</label>
      </b-col>
    </b-row>
    <b-row class="my-1">
      <b-col cols="8">
        <label for="input-small">ราคารวมภาษีมูลค่าเพิ่ม</label>
      </b-col>
      <b-col cols="4" class="text-right">
        <label for="input-small">{{ form.price_vat | number }}</label>
      </b-col>
    </b-row>
    <hr class="my-3" />
    <b-row class="my-1">
      <b-col cols="8">
        <b-form inline>
          <b-form-checkbox
            size="sm"
            v-model="form.check_withholding_tax"
            @input="$emit('calRate')"
          ></b-form-checkbox>
          <label for="input-small">หักภาษี ณ ที่จ่าย</label>
          <b-form-input
            :disabled="!form.check_withholding_tax"
            size="sm"
            class="mx-1 mw-50px text-center"
            v-model="form.withholdingTaxPercent"
            @input="$emit('calRate')"
          ></b-form-input>
          <label for="input-small">%</label>
        </b-form>
      </b-col>
      <b-col cols="4" class="text-right">
        <label for="input-small">{{ form.withholdingTax | number }}</label>
      </b-col>
    </b-row>
    <hr class="my-3" />
    <b-row class="my-1">
      <b-col cols="8">
        <label for="input-small" class="h3">จำนวนเงินรวมทั้งสิ้น</label>
      </b-col>
      <b-col cols="4" class="text-right">
        <label for="input-small" class="h3">{{ form.net | number }}</label>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  components: {},
  props: { form: {} },
  data() {
    return { status: "" };
  },
  created() {},
  methods: {},
  mounted() {},
};
</script>
